var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pivot-table-container" }, [
    !_vm.data || !_vm.data.rows || _vm.data.rows.length === 0
      ? _c(
          "div",
          { staticClass: "empty-state" },
          [
            _c("a-empty", {
              attrs: { description: "Pivot tablosu için veri bulunamadı" },
            }),
          ],
          1
        )
      : _c("div", { staticClass: "pivot-table-wrapper" }, [
          _c("table", { staticClass: "pivot-table" }, [
            _c(
              "thead",
              _vm._l(_vm.columnHeaderRows, function (row, rowIndex) {
                return _c(
                  "tr",
                  { key: "col-header-" + rowIndex },
                  [
                    _vm._l(_vm.rowFieldCount, function (n) {
                      return _c(
                        "th",
                        { key: "empty-" + n, staticClass: "empty-corner-cell" },
                        [
                          rowIndex === 0 && n === 1
                            ? _c("span", [_vm._v(_vm._s(_vm.rowFieldsLabel))])
                            : _vm._e(),
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _vm._l(row, function (cell, colIndex) {
                      return _c(
                        "th",
                        {
                          key: "col-" + colIndex,
                          attrs: {
                            colspan: cell.colspan || 1,
                            rowspan: cell.rowspan || 1,
                          },
                        },
                        [
                          _c("pivot-header-cell", {
                            attrs: {
                              label: cell.label,
                              "is-row-header": false,
                              sortable: false,
                            },
                          }),
                        ],
                        1
                      )
                    }),
                  ],
                  2
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "tbody",
              [
                _vm._l(_vm.visibleDataRows, function (row, rowIndex) {
                  return _c(
                    "tr",
                    { key: "data-row-" + rowIndex },
                    [
                      _vm._l(
                        _vm.visibleHeaders(row.headers),
                        function (headerCell, headerIndex) {
                          return _c(
                            "td",
                            {
                              key: "row-header-" + headerIndex,
                              attrs: { rowspan: headerCell.rowspan || 1 },
                            },
                            [
                              _c("pivot-header-cell", {
                                attrs: {
                                  label: headerCell.label,
                                  level: headerCell.level || 0,
                                  expandable: headerCell.hasChildren,
                                  expanded: _vm.isRowExpanded(row.id),
                                  "is-row-header": true,
                                },
                                on: {
                                  "toggle-expand": function ($event) {
                                    return _vm.toggleRowExpand(row.id)
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        }
                      ),
                      _vm._v(" "),
                      _vm._l(row.cells, function (cell, cellIndex) {
                        return _c(
                          "td",
                          { key: "cell-" + cellIndex },
                          [
                            _c("pivot-cell", {
                              attrs: {
                                value: cell.value,
                                "cell-type": cell.type || "data",
                                "color-config": _vm.config
                                  ? _vm.config.colorSettings
                                  : null,
                                min: _vm.metadata.min,
                                max: _vm.metadata.max,
                                "decimal-format":
                                  _vm.displayOptions.decimalFormat,
                                "empty-cell": _vm.displayOptions.emptyCell,
                                "tooltip-content": cell.tooltip,
                                unit: _vm.getUnitForCell(cellIndex),
                              },
                            }),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  )
                }),
                _vm._v(" "),
                _vm.showTotals && _vm.grandTotalRow
                  ? _c(
                      "tr",
                      { staticClass: "grand-total-row" },
                      [
                        _c(
                          "td",
                          { attrs: { colspan: _vm.rowFieldCount } },
                          [
                            _c("pivot-header-cell", {
                              attrs: {
                                label: "Genel Toplam",
                                "is-row-header": true,
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm._l(
                          _vm.grandTotalRow.cells,
                          function (cell, cellIndex) {
                            return _c(
                              "td",
                              { key: "total-" + cellIndex },
                              [
                                _c("pivot-cell", {
                                  attrs: {
                                    value: cell.value,
                                    "cell-type": "total",
                                    "decimal-format":
                                      _vm.displayOptions.decimalFormat,
                                    "empty-cell": _vm.displayOptions.emptyCell,
                                    unit: _vm.getUnitForCell(cellIndex),
                                  },
                                }),
                              ],
                              1
                            )
                          }
                        ),
                      ],
                      2
                    )
                  : _vm._e(),
              ],
              2
            ),
          ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }